export default "__VITE_ASSET__44391b1f__"